import React from 'react';
import { Box, Container, Typography, Grid, Link, Stack, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import TwitterIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';

function Footer() {
  return (
    <Box
      sx={{
        background: 'linear-gradient(180deg, #1a1a1a, #1f1f1f)',
        color: 'white',
        pt: 4,
        pb: 3,
        width: '100%',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Connect With Us */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ color: '#1e88e5', fontWeight: 'bold' }}>
              Connect With Us
            </Typography>
            <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
              <IconButton
                href="https://www.youtube.com/@cloudsecnetwork"
                color="inherit"
                target="_blank"
                rel="noopener noreferrer"
                size="small"
              >
                <YouTubeIcon />
              </IconButton>
              <IconButton
                href="https://linkedin.com/company/cloudsecnetwork"
                color="inherit"
                target="_blank"
                rel="noopener noreferrer"
                size="small"
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                href="https://x.com/cloudsecnetwork"
                color="inherit"
                target="_blank"
                rel="noopener noreferrer"
                size="small"
              >
                <TwitterIcon /> {/* Now represents X */}
              </IconButton>
              <IconButton
                href="https://github.com/cloudsecnetwork"
                color="inherit"
                target="_blank"
                rel="noopener noreferrer"
                size="small"
              >
                <GitHubIcon />
              </IconButton>
            </Stack>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.85)', mb: 1 }}>
              Email: <Link href="mailto:hello@cloudsecnetwork.com" color="inherit">hello@cloudsecnetwork.com</Link>
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.85)' }}>
              Phone: +1-214-329-9755
            </Typography>
          </Grid>

          {/* Resources Section */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ color: '#1e88e5', fontWeight: 'bold' }}>
              Resources
            </Typography>
            <Link
              href="/training"
              color="inherit"
              variant="body2"
              sx={{
                display: 'block',
                mb: 1,
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Training
            </Link>
            <Link
              href="https://learn.cloudsecnetwork.com"
              target="_blank"
              color="inherit"
              variant="body2"
              sx={{
                display: 'block',
                mb: 1,
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              LMS
            </Link>
            <Link
              href="https://blog.cloudsecnetwork.com"
              target="_blank"
              color="inherit"
              variant="body2"
              sx={{
                display: 'block',
                mb: 1,
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Blog
            </Link>
          </Grid>

          {/* Get Involved Section */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ color: '#1e88e5', fontWeight: 'bold' }}>
              Get Involved
            </Typography>
            <Link
              href="/community"
              color="inherit"
              variant="body2"
              sx={{
                display: 'block',
                mb: 1,
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Community
            </Link>
            <Link
              href="/cloudathon"
              color="inherit"
              variant="body2"
              sx={{
                display: 'block',
                mb: 1,
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Cloudathon
            </Link>
            <Link
              href="/apply"
              target="_blank"
              color="inherit"
              variant="body2"
              sx={{
                display: 'block',
                mb: 1,
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Join Us
            </Link>
          </Grid>
        </Grid>

        {/* Bottom Section */}
        <Typography
          variant="body2"
          align="center"
          sx={{
            mt: 4,
            color: 'rgba(255, 255, 255, 0.75)',
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            pt: 2,
          }}
        >
          © {new Date().getFullYear()} CloudSec Network. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
